import React, { useEffect, useState } from "react";
import images from "../../assets/images";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ROUTES } from "../../constants/routes.constants";
import userService from "../../services/user.service";
import { useDispatch } from "react-redux";
import { userSlice } from "../../redux/slices/user.slice";
import http from "../../utility/http";
import walgreensLogo from "./walgreens.png";
import { getCodeLoginContext } from "../../utility/code-login-context";
import "./index.scss";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const fromCodeLogin = location.state?.fromCodeLogin;
  const codeLoginContext = getCodeLoginContext();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigateAfterLogin = (userData) => {
    if (
      (userData.roleId === 2 ||
        userData.roleId === 3 ||
        userData.roleId === 4) &&
      !userData.pharmacyBranchId
    ) {
      navigate(ROUTES.CHOOSE_PHARMACY_ACCOUNT_ROUTE);
      return;
    }

    if (codeLoginContext?.recordId) {
      navigate(ROUTES.CODE_NOTIFICATION_ROUTE, { replace: true });
      return;
    }

    if (userData.roleId === 7) {
      navigate(ROUTES.TRANSFER_IN_REQUEST_ROUTE);
    } else {
      navigate(ROUTES.DASHBOARD_ROUTE);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check if username is empty
    if (!username || username.length === 0) {
      return;
    }

    // Check if password is empty for regular login
    if (!password || password.length === 0) {
      return;
    }

    // Proceed with normal login
    setIsLoading(true);
    try {
      const loginResult = await userService.Login(username, password);
      if (loginResult.error === null) {
        dispatch(userSlice.actions.login(loginResult.data));
        navigateAfterLogin(loginResult.data?.user);
      } else {
        //Focus on field username
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const LoginCode = async (code) => {
    setIsLoading(true);
    try {
      const loginResult = await http.post("/v1/user/sso/auth", {
        email: code,
        code
      });
      console.log(loginResult);
      if (loginResult.error === null) {
        dispatch(userSlice.actions.login(loginResult.data));
        navigateAfterLogin(loginResult.data?.user);
      } else {
        //Focus on field username
      }
    } catch (error) {
      console.error('Login code error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleWalgreensSSO = () => {
    const ssoUrl = process.env.REACT_APP_WALGREENS_SSO_URL 
    console.log(ssoUrl);
     window.location.href = ssoUrl;
  };

  useEffect(() => {
    document.title = "TransferMyRx::Login";

    // Check for code parameter in URL
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    console.log(code);
    if (code) {
      LoginCode(code);
    }
  }, [location.search]);

  return (
    <>
      {isLoading && (
        <div className={isLoading ? 'card w-100 h-100 d-flex justify-content-center align-items-center position-absolute bg-transparent loading-container' : 'd-none'}>
          <div className="w-100 h-100 position-absolute bg-white opacity-75"></div>
          <div
            className={`d-flex justify-content-flex-start align-items-center position-absolute p-3
               border border-dark shadow-lg rounded-1 loading animate__animated animate__faster
               animate__zoomIn`}
          >
            <div className="spinner-border text-success me-3"></div>
            <span className="">Processing...</span>
          </div>
        </div>
      )}
      <div
        id="login-form"
        className="auth-form p-4 p-sm-5 shadow-lg rounded-1 border-primary bg-white animate__animated"
      >
        <div className="text-center mb-3">
          <a href="https://www.TransferMyRx.com">
            <img src={images.Logo} alt="TransferMyRx" className="img-fluid" />
          </a>
        </div>
        <h5 className="text-center mb-4">Log in to your account</h5>
        {(fromCodeLogin || codeLoginContext?.recordId) && (
          <p className="text-center text-muted mb-3">
            Log in or{" "}
            <Link className="link-default" to={ROUTES.SIGNUP_ROUTE}>
              register
            </Link>{" "}
            to view your TransferMyRx notification.
          </p>
        )}

        <form onSubmit={(event) => handleSubmit(event)} className="form-container">
          <div className="col-12 mb-3">
            <label htmlFor="username" className="form-label">
              User Name
            </label>
            <input
              id="username"
              type="text"
              className="form-control"
              placeholder="User Name"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </div>

          <div className="col-12 mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>

          <div className="form-row d-flex justify-content-between mt-4 mb-2">
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="remember-me-cb"
                />
                <label className="form-check-label" htmlFor="remember-me-cb">
                  Remember me
                </label>
              </div>
            </div>
            <div className="mb-3">
              <Link to={ROUTES.FORGOTPASSWORD_ROUTE} className="link-default">
                Forgot Password?
              </Link>
            </div>
          </div>

          <button
            type="submit"
            className="w-100 mb-2 btn btn-default btn-lg"
          >
            Log In
          </button>

          {/* Walgreens SSO Button */}
          <div className="d-flex align-items-center my-3">
            <hr className="flex-grow-1" />
            <span className="px-3 text-muted small">OR</span>
            <hr className="flex-grow-1" />
          </div>
          
          <button
            type="button"
            className="w-100 btn btn-outline-primary btn-lg mb-3 walgreens-sso-btn d-flex align-items-center justify-content-center"
            onClick={handleWalgreensSSO}
          >
            <img 
              src={walgreensLogo} 
              alt="Walgreens" 
              className="walgreens-logo me-2"
            />
            Continue with Walgreens 
          </button>

          <div className="mt-[20px]">
            By clicking Log In, you have read and agree to the&nbsp;
            <a
              className="link-default"
              href="https://www.transfermyrx.com/#/terms-and-conditions"
              target="_blank"
            >
              Terms and Conditions
            </a>
            &nbsp;and&nbsp;
            <a
              className="link-default"
              href="https://www.transfermyrx.com/#/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </a>
            .
          </div>
        </form>
        <div className="mt-3 text-start ">
          Do you have a login code?&nbsp;
          <Link className="link-default" to={ROUTES.LOGIN_WITH_CODE_ROUTE}>
            Log In With Code
          </Link>
        </div>

        <div className="mt-3 text-start ">
          Don't have an account?&nbsp;
          <Link className="link-default" to={ROUTES.SIGNUP_ROUTE}>
            Sign Up
          </Link>
        </div>
      </div>
    </>
  );
};
export default Login;
